import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BaseChartProps } from "src/pages/dashboard/charts/TemperatureCableChart";
import { useMachineAnnotations } from "./useMachineStatusAnnotations";
import { Skeleton } from "antd";
import React from "react";
import { Line } from "react-chartjs-2";
import dayjs from "dayjs";
import { last } from "lodash";
import { binDBKeys } from "src/pages/binOverview/BinCommander";
import PremierPlusTapestripDTO from "src/models/PremierPlusTapestripDTO";


export const generateSubTitle = (startDate: string | null | undefined, endDate: string | null | undefined): string => {
    if (startDate == null || endDate == null) {
        return '';
    }
    return `${dayjs(startDate).format('MM/DD/YYYY')} - ${dayjs(endDate).format("MM/DD/YYYY")}`;
}

interface MoistureDisplayChartProps extends BaseChartProps{
    tapestrips: PremierPlusTapestripDTO[];
    isLoading: boolean;
}

export const MoistureDisplayChart : React.FC<MoistureDisplayChartProps> = (props) => {


    const statusAnnotations = useMachineAnnotations(props.tapestrips ?? []);

    return <>

        <Skeleton loading={props.isLoading}>
            <section style={{ width: "100%", minHeight: props.chartHeight ?? "50vh" }}>
                {props.tapestrips && <Line options={{
                    scales: {
                        x: {
                            type: "time",
                            //min: value?.[0]?.toISOString(),
                            //max: value?.[1]?.toISOString(),
                            time: {
                                minUnit: 'hour',
                                displayFormats: {
                                }
                            },
                        },
                        y: {
                            type: 'linear',
                            position: 'left',
                            suggestedMin: 14,
                            suggestedMax: 15.5,
                            ticks: {
                                precision: 1,
                            },
                            title: {
                                font: {
                                    size: 16,
                                },
                                display: false,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            position: 'top' as const,
                            display: true,
                        },
                        title: {
                            display: true,
                            text: 'Moisture Graph',
                        },
                        subtitle: {
                            display: props.tapestrips?.length > 1,
                            text: generateSubTitle(props.tapestrips?.[0]?.captureTimeUtc, last(props.tapestrips)?.captureTimeUtc),
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            callbacks: {
                            }
                        },
                        annotation: {
                            annotations: [
                                ...statusAnnotations,
                            ],
                        },
                    },
                }} data={{
                    datasets: [
                        {
                            type: 'line',
                            data: props.tapestrips ?? [], label: "Moisture", indexAxis: 'x',
                            parsing: {
                                yAxisKey: 'individualMc',
                                xAxisKey: 'captureTimeUtc'
                            },
                            spanGaps: true,
                            backgroundColor: "#2933f2",
                            borderColor: "#2933f2",
                        },
                        {
                            type: 'line',
                            // @ts-ignore - different structure than 1st dataset
                            data: props.tapestrips ?? [],
                            label: "Moisture Average",
                            indexAxis: 'x',
                            parsing: {
                                yAxisKey: 'averageMc',
                                xAxisKey: 'captureTimeUtc'
                            },
                            spanGaps: true,
                            stepped: true,
                            backgroundColor: "#07ff4d",
                            borderColor: "#07ff4d",
                        },
                    ]
                }} />}
            </section>
        </Skeleton>
    </>;
};